/**
 * Signer Portal App
 *
 * Public portal for document signing and form submission.
 * Routes:
 * - / - Access code entry (landing page)
 * - /collect/:slug - Contact collection form (public signup)
 * - /sign/:signatureId - Document signing page (legacy PDF)
 * - /sign-ndf/:signatureId - NDF document signing page
 * - /form/:publicUrl - Public form submission (legacy)
 * - /form-ndf/:publicUrl - NDF form submission
 * - /form/:formId/token/:token - Private form with token
 * - /unsubscribe/:token - Email unsubscribe
 * - /confirm-consent/:token - Double opt-in confirmation
 */
import { Unsubscribe } from './pages/Unsubscribe';
import { ConsentConfirmPage } from './pages/ConsentConfirmPage';
import { AccessCode } from './pages/AccessCode';
import { SignDocument } from './pages/SignDocument';
import { SignNdfDocument } from './pages/SignNdfDocument';
import { SubmitForm } from './pages/SubmitForm';
import { SubmitNdfForm } from './pages/SubmitNdfForm';
import { CollectContact } from './pages/CollectContact';
import { NotFoundPage } from './pages/NotFoundPage';

function App() {
  const path = window.location.pathname;

  // Contact collection route: /collect/:slug
  if (path.startsWith('/collect/')) {
    const slug = path.split('/')[2] || '';
    return <CollectContact slug={slug} />;
  }

  // Unsubscribe route: /unsubscribe/:token
  if (path.startsWith('/unsubscribe/')) {
    return <Unsubscribe />;
  }

  // Consent confirmation route: /confirm-consent/:token
  if (path.startsWith('/confirm-consent/')) {
    return <ConsentConfirmPage />;
  }

  // NDF document signing route: /sign-ndf/:signatureId
  if (path.startsWith('/sign-ndf/')) {
    return <SignNdfDocument />;
  }

  // Document signing route: /sign/:signatureId (legacy PDF)
  if (path.startsWith('/sign/')) {
    return <SignDocument />;
  }

  // NDF form route: /form-ndf/:publicUrl
  if (path.startsWith('/form-ndf/')) {
    return <SubmitNdfForm />;
  }

  // Form routes: /form/:publicUrl or /form/:formId/token/:token (legacy)
  if (path.startsWith('/form/')) {
    return <SubmitForm />;
  }

  // Landing page with access code entry
  if (path === '/' || path === '') {
    return <AccessCode />;
  }

  // 404 for unknown routes
  return <NotFoundPage />;
}

export default App;
